export enum ImageUploadErrorKind {
  // Still at or over the Storage size rule after prepareImageForUpload, which
  // can only shrink what the browser can decode (not TIFF in Chromium).
  TooLarge = 'image-too-large',
}

// An upload outcome the image picker shows; thrown before the request that the
// Storage rule would refuse with `storage/unauthorized`.
export class ImageUploadError extends Error {
  constructor(public readonly kind: ImageUploadErrorKind) {
    super(`Image upload failed: ${kind}`);
    this.name = 'ImageUploadError';
  }
}
